import apiClient from "../BaseUrl/apiClient.js";
import React, { useEffect, useRef, useState } from "react";
import TokenService from "../service/TokenService";
import DashBoardBoxItems from "../components/DashBoardBoxItems";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SriyanshCardHeader from "../components/CardHeader";
import WhatsAppButton from "../whatsapp/WhatsAppButton.js";


//import { useAuthentication } from "../customHook/useAuthentecation";

//import CircularProgress from "@mui/material/CircularProgress";
import PoReport from "../masterpages/Reports/Po/PoReport";
import { BoxStyle } from "../constantVaribles/constatanvariable";
function PgHome() {
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  // const role = tokenServiceDetails?.role;
  // const fullname = tokenServiceDetails?.FullName;
  // const consignee = tokenServiceDetails?.consignee;
  const reportRef = useRef(null);
  //const [pageLoader, setPageLoader] = useState(false);
  const [poData, setpoData] = useState("");
  const [itemnotreceived, setitemnotreceived] = useState("");
  const [suitability, setsuitability] = useState("");
  const [billpending, setbillpending] = useState("");
  const [cospending, setcospending] = useState("");
  const [accountpending, setaccountpending] = useState("");
  const [paymentpending, setpaymentpending] = useState("");
  const [paid, setpaid] = useState("");
  const [generateReportClick, setgenerateReportClick] = useState(false);
  const [report, setreport] = useState("");
  const [reporthead, setreporthead] = useState("");

  // const pendingPO ={
  //   setreport(1);
  //   setgenerateReportClick(true);

  // }


  




  const pending = async (reporttype, reporthd) => {
    setreport(reporttype);
    setgenerateReportClick(true);
    setreporthead(reporthd);
  };

  const clearData = async () => {
    setreport("");
    setgenerateReportClick(false);
    setreporthead("");
  };
  const reportData = {
    consignee: "Select All",
    reporttype: report,
    reportsubtype: "",
    reportHeading: reporthead,
  };

  const getdata = async (e) => {
    // setPageLoader(true);
    apiClient
      .post("/getdashboarddata", {
        uname: uname,
      })
      .then(function (response) {
        setpoData(response.data[0].po);
        setitemnotreceived(response.data[0].notreceived);
        setsuitability(response.data[0].suitability);
        setbillpending(response.data[0].billpending);
        setcospending(response.data[0].cospending);
        setaccountpending(response.data[0].accountpending);
        setpaymentpending(response.data[0].paymentpending);
        setpaid(response.data[0].paid);
      })
      .catch(function (error) {
        alert(error);
      });
    //setPageLoader(false);
  };

  useEffect(() => {
    if (generateReportClick && reportRef.current) {
      reportRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    getdata();
  }, [getdata, generateReportClick]);

  //const aa = EncryptService.encrypt("token8");
  //const { auth } = useAuthentication();
  return (
    <>
      {/* <SriyanshCardHeader Title={<>Main DashBoard</>} /> */}
   
      {
        <Card className="Formcard">
          <div className="input-groupHeading" >
            <SriyanshCardHeader />
          </div>

          <CardContent>
            {/* {pageLoader ? (
              <div className="loaderContainer">
                {" "}
                <CircularProgress />{" "}
              </div>
            ) : ( */}
            <div className="row">
              {/* ------------1----------------------- */}

              {/* {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="DarkCyan"
                textcolor="white"
                title="Pending PO"
                Data={poData}
                //navigatePath="polist"
                onClickFunction={pending}
                onClickParams={[1, "Pending PO"]}
              />
              {/* )} */}
              {/* ------------2----------------------- */}

              {/* {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="DarkGreen"
                title="Material Receiving Pending"
                textcolor="white"
                Data={itemnotreceived}
                //navigatePath="itemreceivedlist"
                onClickFunction={pending}
                onClickParams={[2, "Materials Receiving Pending"]}
              />
              {/* )} */}

              {/* ------------3----------------------- */}

              {/* {(auth?.userrights === USER_RIGHTS.SSEI ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="Crimson"
                title="Suitability Pending"
                textcolor="white"
                Data={suitability}
                //navigatePath="suitabilitylist"
                onClickFunction={pending}
                onClickParams={[3, "Suitability Pending"]}
              />
              {/* )} */}
              {/* ------------4----------------------- */}
              {/* {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="DarkGoldenRod"
                title="Bill Pending from Firm"
                textcolor="white"
                Data={billpending}
                //navigatePath="billpendinglist"
                onClickFunction={pending}
                onClickParams={[4, "Bill Receiving Pending from Firm"]}
              />
              {/* )} */}
              {/* ------------5----------------------- */}
              {/* {(auth?.userrights === USER_RIGHTS.COSG ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="#8B4513"
                title="Bill Passing/Funding Pending"
                textcolor="white"
                Data={cospending}
                //navigatePath="cosglist"
                onClickFunction={pending}
                onClickParams={[5, "Bill Passing Pending"]}
              />
              {/* )} */}

              {/* ------------6----------------------- */}
              {/* {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="Black"
                title="CRN Pending"
                textcolor="white"
                Data={accountpending}
                // navigatePath="accountpendiglist"
                onClickFunction={pending}
                onClickParams={[6, "CRN Pending"]}
              />
              {/* )} */}
              {/* ------------7----------------------- */}
              {/* {(auth?.userrights === USER_RIGHTS.ACCOUNTS ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="Maroon"
                title="Payment Pending"
                textcolor="white"
                Data={paymentpending}
                //navigatePath="paymentlist"
                onClickFunction={pending}
                onClickParams={[7, "Payment Pending"]}
              />
              {/* )} */}

              {/* ------------8 Paid----------------------- */}
              {/* {(auth?.userrights === USER_RIGHTS.CONSIGNEE || 
auth?.userrights === USER_RIGHTS.ACCOUNTS ||
                  auth?.userrights === USER_RIGHTS.ADMIN) && ( */}
              <DashBoardBoxItems
                backcolor="Navy"
                title="Payment Done"
                textcolor="white"
                Data={paid}
                //navigatePath="paymentlist"
               // disabled={true}
                onClickFunction={clearData}
                onClickParams={[0, "Paid"]}
              />
              {/* )} */}
              {/* <DashBoardBoxItems
                backcolor="green"
                title="Clean Report Area"
                textcolor="white"
                Data={"🧹"}
                //navigatePath="paymentlist"
                onClickFunction={clearData}
                onClickParams={[0, "Clear"]}
              /> */}
            </div>
            {/* ) } */}
          </CardContent>
        </Card>
      }

      {generateReportClick && (
        <div id="report11" ref={reportRef}>
          {/* <div style={{ textAlign: "center", color: "white" }}>
            <h4>{reporthead}</h4>
          </div> */}
          <PoReport
            consignee={reportData.consignee}
            reporttype={reportData.reporttype}
            reportsubtype={reportData.reportsubtype}
            heading={reporthead}
            
          />
        </div>
      )}


      {/* <SriyanshCardHeader
        Title={
          <div
            style={{
              display: "flex",

              alignItems: "center",
              width: "100%",
            }}
          ></div>
        }
      /> */}


<WhatsAppButton />



    </>
  );
}

export default PgHome;
